import React from 'react'
import './HeaderComp.css';

function HeaderComp() {
  return (
    <div className="HeaderComp">
      <h1>SemiAutomatic Trader</h1>
    </div>
  )
}

export default HeaderComp